import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import { ApiKeySummary } from "../../generated/core-api";

const MCP_KEYS_QUERY_KEY = ["mcp-api-keys"];
const EXPIRY_WARNING_DAYS = 7;

function isExpiringSoon(key: ApiKeySummary): boolean {
  if (key.revoked_at || !key.expires_at) return false;
  const expiryDate = new Date(key.expires_at);
  const warningDate = new Date();
  warningDate.setDate(warningDate.getDate() + EXPIRY_WARNING_DAYS);
  return expiryDate <= warningDate && expiryDate > new Date();
}

export function useExpiringMcpKeys() {
  const keysQuery = useQuery({
    queryKey: MCP_KEYS_QUERY_KEY,
    queryFn: () => api.listMcpApiKeys(),
  });

  const expiringKeys = useMemo(
    () => (keysQuery.data ?? []).filter(isExpiringSoon),
    [keysQuery.data]
  );

  return { expiringKeys, isLoading: keysQuery.isLoading };
}
